import { AppointmentWidget } from "../../components/widgets";
import { ProfileRole } from "../../store/profile/profileSlice";

const StudentTab = ({ profile }) => {
    if (!profile?._id) return null;
    const role =
        profile.role === ProfileRole.STUDENT || profile.role === 3 || profile.role === "3"
            ? ProfileRole.STUDENT
            : profile.role;
    return <AppointmentWidget profile={profile._id} role={role} />;
};

export { StudentTab };